<script setup>
import { ref } from 'vue'
import { useApi } from '../../shared/composables/useApi.js'

const props = defineProps({
  csrfToken: { type: String, required: true },
})

const { post } = useApi(props.csrfToken)

const email = ref('')
const error = ref('')
const submitted = ref(false)
const busy = ref(false)

async function submit() {
  if (busy.value) return
  error.value = ''
  busy.value = true
  const { ok, data } = await post('/api/auth/forgot', { email: email.value })
  busy.value = false
  if (ok) {
    submitted.value = true
  } else {
    error.value = data.error || 'Could not send reset link.'
  }
}
</script>

<template>
  <div class="auth-card hf-glass">
    <h1>Forgot Password</h1>

    <div v-if="error" class="error" role="alert">{{ error }}</div>

    <div v-if="submitted" class="success">
      If that email is registered, you'll receive a reset link shortly.
    </div>
    <template v-else>
      <p class="auth-intro">Enter your email address and we'll send you a link to reset your password.</p>

      <form novalidate @submit.prevent="submit">
        <div class="form-group">
          <label for="email">Email address</label>
          <input
            id="email"
            v-model="email"
            class="hf-input"
            type="email"
            name="email"
            autocomplete="email"
            required
            autofocus
          />
        </div>
        <button type="submit" class="hf-btn primary auth-submit" :disabled="busy">
          {{ busy ? 'Sending…' : 'Send Reset Link' }}
        </button>
      </form>
    </template>

    <div class="auth-links">
      <a href="/login">Back to log in</a>
    </div>
  </div>
</template>
